import * as atatus from 'atatus-spa';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpClient } from '@angular/common/http';
import { appTranslationsInitializerFactory, AtatusErrorHandler, ERROR_LOGGER_PROVIDERS, LOG_LOGGER_PROVIDERS, Logger, Utils, } from '@clickd-angular/common-lib';
import { environment } from '../environments/environment';
import { version } from '../environments/version';
if (environment.name !== 'LOCAL') {
    //we want atatus to run only on production environments includeing dev/qa/pre-prod
    atatus
        .config('074b38131a1748af9d90ec5f55c5f3de', {
        // Enable or Disable all console activity
        console: true,
        // By default Atatus will watch all console activity and include that information in the Timeline
        consoleTimeline: true,
        // Set this to false if you don't want your users seeing anything when the dev tools open.
        consoleDisplay: true,
        // Set this to false if you don't want console.error() to trigger errors.
        consoleErrorNotify: true,
        // Specify levels only if you want to watch certain console functions
        consoleTimelineLevels: ['log', 'debug', 'info', 'warn', 'error'],
    })
        .install()
        .setUser(Utils.getParameterByName('accountKey'))
        .setCustomData({
        userid: Utils.getParameterByName('userid'),
    });
}
// AoT requires an exported function for factories
export function multiHttpLoaderFactory(http) {
    return new MultiTranslateHttpLoader(http, [
        { prefix: './assets/i18n/common/', suffix: '.json' },
        { prefix: './assets/i18n/', suffix: '.json' },
    ]);
}
export function versionLoggerFactory(logger) {
    return function () {
        return new Promise(function (resolve) {
            logger.log(version);
            resolve();
        });
    };
}
export function atatusErrorHandlerFactory() {
    return new AtatusErrorHandler(Utils.getParameterByName('accountKey'), environment.name);
}
// Decide on the right logger config based on the type of environment
var LoggerProviderBasedOnEnvironment = environment.production
    ? ERROR_LOGGER_PROVIDERS
    : LOG_LOGGER_PROVIDERS;
var ɵ0 = appTranslationsInitializerFactory, ɵ1 = environment.mscrmappServiceApiUrl, ɵ2 = environment.credentialsUrl;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2 };
